(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/text/assets/javascripts/text.js') >= 0) return;  svs.modules.push('/components/utils/text/assets/javascripts/text.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.utils = svs.utils || {};
  svs.utils.text = svs.utils.text || {};


  svs.utils.text.matchText = function(
    node,
    regex,
    callback,
    optExcludeElements
  ) {
    optExcludeElements ||
      (optExcludeElements = ['script', 'style', 'iframe', 'canvas']);
    var child = node.firstChild;

    while (child) {
      switch (child.nodeType) {
        case 1:
          if (optExcludeElements.indexOf(child.tagName.toLowerCase()) > -1) {
            break;
          }
          this.matchText(child, regex, callback, optExcludeElements);
          break;
        case 3:
          var bk = 0;
          child.data.replace(regex, function(all) {
            var args = [].slice.call(arguments);
            var offset = args[args.length - 2];
            var newTextNode = child.splitText(offset + bk);
            var tag;
            bk -= child.data.length + all.length;

            newTextNode.data = newTextNode.data.substr(all.length);
            tag = callback.apply(window, [child].concat(args));
            child.parentNode.insertBefore(tag, newTextNode);
            child = newTextNode;
          });
          break;
        default:
      }
      child = child.nextSibling;
    }

    return node;
  };
})(svs);

 })(window);